"use client";
import React, { useState, useCallback, Suspense } from "react";
import Logo from "@/public/assets/icons/LeftSidebar/Logo.svg";
import { SignInButton, SignedOut, SignUpButton } from "@clerk/nextjs";
import Link from "next/link";
import { navLinks } from "@/constants";
import { Icons } from "@/components/(new)/shared/helper/Icons";
import dynamic from "next/dynamic";

// Lazy load the mobile menu
const MobileMenu = dynamic(() => import("./MobileMenu"), { ssr: false });

const LandingNav = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  return (
    <div className="relative z-10">
      <nav className="relative z-10 flex items-center justify-between px-5 py-2.5 md:px-[30px] md:py-[32.5px]">
        {/* button to open menu in mobile screens */}

        <Icons.menu
          onClick={handleOpen}
          aria-label="Toggle menu"
          className="size-6 text-white focus:outline-hidden lg:hidden"
        />

        <Link
          href="/"
          className="flex-center gap-2.5 outline-none max-md:py-1.5"
        >
          <Logo className="h-[22px] md:h-[25px]" />
          <div className="font-worksans text-base font-medium -tracking-[1px] md:text-2xl md:text-[19.7px] md:-tracking-[1.1px]">
            Bundled.design
          </div>
        </Link>

        <div className="lg:flex-center absolute top-1/2 left-1/2 hidden h-[60px] -translate-x-1/2 -translate-y-1/2 gap-[5px] rounded-full border border-[#333333] bg-[#141414] px-5">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="px-4 py-0.5 text-base font-semibold text-white"
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* button to signin signup */}
        <div className="flex items-center gap-5">
          <SignedOut>
            <SignInButton
              forceRedirectUrl="/image-generator"
              signUpForceRedirectUrl="/image-generator?showBanner=true"
            >
              <button className="cursor-pointer text-base font-semibold md:px-3">
                Log In
              </button>
            </SignInButton>
          </SignedOut>
          <div className="max-lg:hidden">
            <SignedOut>
              <SignUpButton
                forceRedirectUrl="/image-generator?showBanner=true"
                signInForceRedirectUrl="/image-generator"
              >
                <button className="cursor-pointer rounded-full bg-gradient-to-b from-[#6CB5FF] to-[#1E7BDB] px-[30px] py-[15px] text-base font-medium text-nowrap">
                  Get Started
                </button>
              </SignUpButton>
            </SignedOut>
          </div>
        </div>
      </nav>

      {open && (
        <Suspense
          fallback={<div className="fixed inset-0 z-40 bg-black lg:hidden" />}
        >
          <MobileMenu onClose={handleOpen} />
        </Suspense>
      )}
    </div>
  );
};

export default React.memo(LandingNav);
